import styled from "@emotion/styled";
import { LightMode, Tab, Tabs, Variables, gearIcon } from "@repo/skapa";
import {
  DEFAULT_LOCALE,
  getLanguageAndLocaleFromUrl,
  t,
} from "@repo/translation";
import {
  ButtonsContainer,
  CustomerModeToggle,
  FlexDiv,
  Line,
  ResponsiveButton,
} from "@repo/ui";

import { type TabOptions } from "./types";

const Container = styled.div`
  padding: 0 24px;
  background-color: ${LightMode.colourStaticWhite};
`;

const HeaderTabs = styled(Tabs)`
  .saleslead__tabs__list::before {
    content: none;
  }
`;

interface SubHeaderTabsProps<T extends string> {
  activeTabPanelId: T;
  tabs: TabOptions[];
}

export function SubHeaderTabs<T extends string>({
  tabs,
  activeTabPanelId,
}: SubHeaderTabsProps<T>) {
  const locale = getLanguageAndLocaleFromUrl();
  const { country, language } = locale ?? DEFAULT_LOCALE;

  // Only show toggle in sales lead
  const showCustomerModeToggle = !window.location.pathname.includes("bas");

  const activeTab =
    tabs.find((tab) => tab.url === location.pathname)?.tabPanelId ||
    activeTabPanelId;

  return (
    <Container>
      <FlexDiv
        justifyContent="space-between"
        alignItems="center"
        gap={Variables.space50}
      >
        <HeaderTabs
          activeTab={activeTab}
          tabs={tabs.map((tab) => (
            <Tab
              key={tab.tabPanelId}
              text={t(tab.label)}
              tabPanelId={tab.tabPanelId}
              onClick={() => {
                if (tab.url) {
                  window.location.href = tab.url;
                }
              }}
            />
          ))}
        />
        <ButtonsContainer>
          {activeTab === "WORKSPACE_TAB" && (
            <ResponsiveButton
              breakpoint="md"
              text={t("action.customize")}
              aria-label="icon-button"
              ssrIcon={gearIcon}
              size="small"
              onClick={() => {
                window.location.href = `/${country}/${language}/saleslead/customize`;
              }}
            />
          )}
          {showCustomerModeToggle && <CustomerModeToggle />}
        </ButtonsContainer>
      </FlexDiv>
      <Line />
    </Container>
  );
}
